import React from 'react';

import type { ChartV2Insight } from '../types/chart-v2.types';

interface MockMarkerProps {
  label: string;
  title: string;
  background: string;
  color?: string;
}

const MockMarker = ({
  label,
  title,
  background,
  color = '#0b0c0f',
}: MockMarkerProps) => (
  <div
    title={title}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 18,
      height: 18,
      borderRadius: '50%',
      background,
      color,
      fontSize: 10,
      fontWeight: 700,
      lineHeight: 1,
      boxShadow: '0 0 0 2px var(--chartv2-background, rgba(0, 0, 0, 40%))',
      cursor: 'pointer',
      userSelect: 'none',
    }}
  >
    {label}
  </div>
);

const d = (year: number, month: number, day = 1): number =>
  Date.UTC(year, month - 1, day, 16, 0, 0, 0);

export const mockChartV2Insights: ChartV2Insight[] = [
  {
    id: 'aapl-earnings-2013-01',
    time: d(2013, 1, 23),
    icons: [
      <MockMarker
        key="e"
        label="E"
        title="AAPL earnings — Q1 2013"
        background="#a78bfa"
      />,
    ],
  },
  {
    id: 'aapl-split-2014',
    time: d(2014, 6, 9),
    icons: [
      <MockMarker
        key="s"
        label="S"
        title="AAPL 7-for-1 stock split"
        background="#f59e0b"
      />,
    ],
  },
  {
    id: 'msft-dividend-2016',
    time: d(2016, 11, 17),
    icons: [
      <MockMarker
        key="d"
        label="D"
        title="MSFT dividend paid"
        background="#34d399"
      />,
    ],
  },
  {
    id: 'market-event-2020-03',
    time: d(2020, 3, 23),
    icons: [
      <MockMarker
        key="n"
        label="N"
        title="Market drawdown — COVID low"
        background="#ef4444"
        color="#ffffff"
      />,
      <MockMarker
        key="e"
        label="E"
        title="AAPL earnings — Q2 2020"
        background="#a78bfa"
      />,
    ],
  },
  {
    id: 'nvda-ai-boom-2023',
    time: d(2023, 5, 24),
    icons: [
      <MockMarker
        key="n"
        label="N"
        title="NVDA datacenter guidance blowout"
        background="#ef4444"
        color="#ffffff"
      />,
    ],
  },
  {
    id: 'aapl-vision-pro-2024',
    time: d(2024, 2, 2),
    icons: [
      <MockMarker
        key="n"
        label="N"
        title="AAPL Vision Pro launches"
        background="#ef4444"
        color="#ffffff"
      />,
    ],
  },
  {
    id: 'aapl-earnings-2025-q4',
    time: d(2025, 10, 30),
    icons: [
      <MockMarker
        key="e"
        label="E"
        title="AAPL earnings — Q4 2025"
        background="#a78bfa"
      />,
      <MockMarker
        key="d"
        label="D"
        title="AAPL dividend"
        background="#34d399"
      />,
    ],
  },
];
